import { render } from "./TyreCard.vue?vue&type=template&id=17bb7334&scoped=true"
import script from "./TyreCard.vue?vue&type=script&lang=js"
export * from "./TyreCard.vue?vue&type=script&lang=js"

import "./TyreCard.vue?vue&type=style&index=0&id=17bb7334&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17bb7334"]])

export default __exports__